// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.op-form-time-range-picker .ant-picker{width:100%}`, "",{"version":3,"sources":["webpack://./app/new-components/DLS/OpForm/formComponents/OpFormTimeRangePicker/OpFormTimeRangePicker.scss"],"names":[],"mappings":"AACE,uCACE,UAAA","sourcesContent":[".op-form-time-range-picker {\n  .ant-picker {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
